import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {Farm, PostFarmBody} from "../types/domain/farm";

export const getAllFarms = async (
    companyId: string,
    onlyActiveOrders?: boolean,
    removeEmptyFarms?: boolean,
    year?: number,
): Promise<Farm[]> => {
    const queryParams = new URLSearchParams();
    if (onlyActiveOrders !== undefined) queryParams.append("onlyActiveOrders", onlyActiveOrders.toString());
    if (removeEmptyFarms !== undefined) queryParams.append("removeEmptyFarms", removeEmptyFarms.toString());
    if (year !== undefined) queryParams.append("year", year.toString());

    const url = queryParams.toString()
        ? `/companies/${companyId}/farms?${queryParams.toString()}`
        : `/companies/${companyId}/farms`;

    const farms = await apiClient
        .get<Farm[]>(url)
        .then((response) => response.data)
        .catch(handleAxiosError);

    return farms;
};

export const createFarm = async (companyId: string, body: PostFarmBody): Promise<Farm> => {
    return await apiClient
        .post<Farm>(`/companies/${companyId}/farms`, body)
        .then((response) => response.data)
        .catch(handleAxiosError);
};
export const editFarm = async (companyId: string, id: string, body: PostFarmBody): Promise<Farm> => {
    return await apiClient
        .put<Farm>(`/companies/${companyId}/farms/${id}`, body)
        .then((response) => response.data)
        .catch(handleAxiosError);
};

export const deleteFarm = async (companyId: string, id: string) => {
    await apiClient.delete(`/companies/${companyId}/farms/${id}`).catch(handleAxiosError);
};

export const getFarmsAlerts = async (companyId: string, date: string): Promise<Farm[]> => {
    return await apiClient
        .get<Farm[]>(`/companies/${companyId}/farms/alerts/${date}`)
        .then((response) => response.data)
        .catch(handleAxiosError);
};
